import { FleekError } from './FleekError';

type ProjectWithSubscriptionCannotBeDeletedOptions = Record<never, string>;

export class ProjectWithSubscriptionCannotBeDeleted extends FleekError<ProjectWithSubscriptionCannotBeDeletedOptions> {
  public name = 'ProjectWithSubscriptionCannotBeDeleted';

  toString = () => `The Project have active subscripiton for a billing plan, please cancel it before deleting the project`;
}
